import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Auth3 from "../../../api/Auth3";
import { toast } from "react-toastify";

export const fetchSubscriptionPlans = createAsyncThunk(
  "subscriptions/getPlans",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Auth3.get("/subscription/plans");
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.detail || "Failed to fetch subscription plans.";
      return rejectWithValue(errorMessage);
    }
  }
);

const subscriptionSlice = createSlice({
  name: "subscriptions",
  initialState: {
    isLoading: false,
    error: null,
    subscriptionPlans: [],
    loadingPlanId: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptionPlans.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSubscriptionPlans.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subscriptionPlans = action.payload;
      })
      .addCase(fetchSubscriptionPlans.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        toast.error(state.error);
      })
  },
});

export default subscriptionSlice.reducer;
